import { byProductMarketcap } from './service'
import { useWindowSize } from 'hooks'

import DesktopOverview from './desktop'
import MobileOverview from './mobile'
import { OverViewWrapper } from './styled'
import React from 'react'
import { useTourGuide } from 'context/tour-guide/use-tour-guide'
import { getOverviewStorage } from './storage'
import { ProductOverview } from './storage/interface'
import GenericMetaTag from 'pages/overview/component/overview-meta-tags'
import { BASE_META_DESCRIPTION } from 'app-constants'

export interface OverviewProps {
  overviewProducts: ProductOverview[]
}

/**
 * TODO:
 
 * 2. add suspense and hydration layer
 * 3. flesh out storage layer
 * 4. pass into necessary areas
 */
export const OverviewPageWrapper: React.FC = () => {
  const { isMobile, isTablet } = useWindowSize()
  const smaller = isMobile || isTablet
  const { products } = getOverviewStorage()
  const { requestTourStart, startTour, run } = useTourGuide()
  const sortedProducts = products.filter((el) => !el.isError).sort(byProductMarketcap)

  React.useEffect(() => {
    if (run) return
    if (requestTourStart) {
      startTour()
    }
  }, [requestTourStart, run])
  return (
    <OverViewWrapper>
      <GenericMetaTag pathname={'/'} description={BASE_META_DESCRIPTION} rightHandTitle={'Home'} />
      {smaller ? (
        <MobileOverview overviewProducts={sortedProducts} />
      ) : (
        <DesktopOverview overviewProducts={sortedProducts} />
      )}
    </OverViewWrapper>
  )
}
